import React, { useContext } from 'react';
import { EventContext } from '../../../../../pages/Activity/context/EventProvider';

import './Legend.scss';

export default function Legends() {
  const { eventFontColors, eventBorderColors, eventBackgroundColors } =
    useContext(EventContext);

  return (
    <div className="px-1 small-calendar-legend">
      <div className="mb-1">
        <DotName
          name="Planned Event"
          dotColor={eventBackgroundColors['Planned Event']}
          dotBorderColor={eventBorderColors['Planned Event']}
          nameColor={eventFontColors['Planned Event']}
        />
      </div>
      <div className="mb-1">
        <DotName
          name="System Event"
          nameColor={eventFontColors['System Event']}
          hasDot={false}
        />
      </div>
      <div className="px-3 small-calendar-legend__group mb-1">
        <DotName
          name="Annual Leave"
          dotColor={eventBackgroundColors['Annual Leave']}
          dotBorderColor={eventBorderColors['Annual Leave']}
          nameColor={eventFontColors['Annual Leave']}
        />
        <DotName
          name="Other Leaves"
          dotColor={eventBackgroundColors['Other Leave']}
          dotBorderColor={eventBorderColors['Other Leave']}
          nameColor={eventFontColors['Other Leave']}
        />
      </div>

      <div className="mb-1">
        <DotName
          name="Today"
          dotColor={eventBackgroundColors?.Today}
          dotBorderColor={eventBorderColors?.Today}
          nameColor={eventFontColors?.Today}
        />
      </div>
      <div className="mb-1">
        <DotName
          name="Weekend"
          dotColor={eventBackgroundColors?.Weekend}
          dotBorderColor={eventBorderColors?.Weekend}
          nameColor={eventFontColors?.Weekend}
        />
      </div>
    </div>
  );
}

function DotName({
  dotColor = '#000000',
  dotBorderColor = '#000000',
  name = '',
  nameColor = '#000000',
  hasDot = true,
}) {
  return (
    <div className="px-2 small-calendar-legend__item">
      {hasDot && (
        <span
          className="small-calendar-legend__dot"
          style={{
            backgroundColor: dotColor,
            borderColor: dotBorderColor,
          }}
        />
      )}
      <span
        className="small-calendar-legend__text"
        style={{ color: nameColor }}
      >
        <strong>{name}</strong>
      </span>
    </div>
  );
}
